import { useState } from "react";
import { Link } from "react-router-dom";
import { AuthShell } from "@/components/AuthShell";
import { GoogleButton } from "@/components/GoogleButton";
import { InstallButton } from "@/components/InstallButton";
import { api, formatError } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

export default function AuthPage() {
  const { setUser } = useAuth();
  const [mode, setMode] = useState("login");
  const [form, setForm] = useState({ name: "", email: "", password: "" });
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);
  const isLogin = mode === "login";

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setError("");
    try {
      const { data } = await api.post(isLogin ? "/auth/login" : "/auth/register", form);
      setUser(data);
    } catch (err) {
      setError(formatError(err));
    } finally {
      setBusy(false);
    }
  };

  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  return (
    <AuthShell kicker={isLogin ? "Accesso" : "Nuovo account"} title={isLogin ? "Bentornato." : "Crea il tuo studio."}>
      <GoogleButton />
      <div className="flex items-center gap-4 my-8">
        <span className="flex-1 border-t rf-line" />
        <span className="rf-mono text-[10px] tracking-[0.3em] uppercase text-[var(--rf-grey)]">oppure con email</span>
        <span className="flex-1 border-t rf-line" />
      </div>
      <form onSubmit={submit} className="space-y-8" data-testid="auth-form">
        {!isLogin && (
          <label className="block">
            <span className="rf-mono text-[11px] uppercase tracking-widest text-[var(--rf-grey)]">Nome</span>
            <input className="rf-input" value={form.name} onChange={set("name")} data-testid="auth-name-input" />
          </label>
        )}
        <label className="block">
          <span className="rf-mono text-[11px] uppercase tracking-widest text-[var(--rf-grey)]">Email</span>
          <input type="email" required className="rf-input" value={form.email} onChange={set("email")} data-testid="auth-email-input" />
        </label>
        <label className="block">
          <span className="rf-mono text-[11px] uppercase tracking-widest text-[var(--rf-grey)]">Password</span>
          <input type="password" required minLength={6} className="rf-input" value={form.password} onChange={set("password")} data-testid="auth-password-input" />
        </label>
        {error && <p className="text-sm rf-red" data-testid="auth-error">{error}</p>}
        <div className="flex flex-wrap items-center gap-6 pt-2">
          <button className="rf-btn" disabled={busy} data-testid="auth-submit-button">
            {busy ? "Attendere…" : isLogin ? "Accedi" : "Registrati"}
          </button>
          {isLogin && (
            <Link to="/forgot-password" className="text-sm underline underline-offset-4 hover:text-[var(--rf-red)]" data-testid="auth-forgot-link">
              Password dimenticata?
            </Link>
          )}
        </div>
      </form>
      <div className="mt-16 pt-6 border-t rf-line text-sm text-[var(--rf-grey)]">
        {isLogin ? "Non hai un account?" : "Hai già un account?"}{" "}
        <button type="button" onClick={() => { setMode(isLogin ? "register" : "login"); setError(""); }}
          className="font-bold text-[var(--rf-ink)] underline underline-offset-4 hover:text-[var(--rf-red)]" data-testid="auth-toggle-mode-button">
          {isLogin ? "Registrati" : "Accedi"}
        </button>
        <div className="mt-8"><InstallButton className="rf-btn-ghost" /></div>
      </div>
    </AuthShell>
  );
}
